import { createContext, ReactNode, useContext } from "react";

export type NodePanelProps<T = unknown> = {
  nodeId: string;
  data: T;
  onUpdate: (data: T) => void;
};

const NodePanelContext = createContext<NodePanelProps | null>(null);

export function PanelContainer<T = unknown>({
  children,
  nodeProps,
}: {
  children: ReactNode;
  nodeProps: NodePanelProps<T>;
}) {
  return (
    <NodePanelContext.Provider value={nodeProps as NodePanelProps | null}>
      {children}
    </NodePanelContext.Provider>
  );
}

export function useNodePanelContext<T = unknown>(): NodePanelProps<T> {
  const context = useContext(NodePanelContext);
  if (!context) {
    throw new Error("useNodePanelContext must be used within PanelContainer");
  }
  return context as NodePanelProps<T>;
}
